import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody, ModalHeader, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { Body2, BoldText } from 'ui/theme';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { sendPasswordResetRequest } from '../../actions';
import { fullName } from '../../utils';
import {
  MODAL_NAMES,
  useOrganizationModalsContext,
  MemberPayload,
} from '../../contexts/OrganizationModalsContext';

const Body2Light = styled(Body2)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const ResetPasswordModal = () => {
  const dispatch = useDispatch();
  const { hideModal, modalState } = useOrganizationModalsContext();

  const { member } = modalState?.payload as MemberPayload;

  const onSubmit = () => {
    dispatch(sendPasswordResetRequest(member));
    hideModal();
  };

  return (
    <Modal
      id="reset-password-modal"
      isModalOpen={modalState?.name === MODAL_NAMES.RESET_PASSWORD}
      onClose={hideModal}
      variant={MODAL_VARIANTS.WARNING}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Reset password?</ModalHeader>
      <ModalBody>
        <Body2Light>
          Are you sure you want to send a password reset for{' '}
          <BoldText>
            {fullName(member)} ({member.email})
          </BoldText>
          ?
        </Body2Light>
        <Body2Light>
          They’ll receive an email with a link and instructions to update their password.
        </Body2Light>
      </ModalBody>
      <ModalFooter>
        <PrimaryButton size={BUTTON_SIZES.LARGE} onClick={onSubmit}>
          Reset password
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
